import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    // Automatically set mobile-friendly inputMode for numeric types
    const getInputMode = () => {
      if (props.inputMode) return props.inputMode;
      if (type === "number") {
        return props.step && (props.step === "0.1" || props.step === "0.5" || props.step === "any") 
          ? "decimal" 
          : "numeric";
      }
      return undefined;
    };

    return (
      <input
        type={type}
        inputMode={getInputMode()}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
